const BookingsTab = () => {
  return <div>BookingsTab</div>;
};

export default BookingsTab;
